import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_REPORT_API } from "./apiRoutes";
interface UseGetReconciliationReportProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getReconciliationReport = async (communityId: string, year: string) =>
  await axiosAuth.get(`${DISTRIBUTION_REPORT_API}/${communityId}/year/${year}/reports/reconciliation`);

const useGetReconciliationReport = ({
  queryParams,
  communityId,
  year
}: UseGetReconciliationReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["reconciliation-report", communityId, year],
    queryFn: () => getReconciliationReport(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!queryParams?.enabled,
  });
};

export default useGetReconciliationReport;
